import { SET_STOCK, SET_STOCK_DATA, DELETE_STOCK, SET_STOCK_LOADING } from "../../../actions";
import toPairs from 'lodash.topairs';
import omit from "lodash.omit";

export const stock = ( state = {}, action) => {
    switch(action.type) {
        case SET_STOCK_DATA: {
            return {...state, loading: false, data: action.payload}
        }
        case SET_STOCK: {
            const { stock, data } = action.payload;
            return {...state, data: {...state.data, [stock]: data} };
        }
        case DELETE_STOCK: {
            const { stock } = action.payload
            return {...state, data: omit(state.data, [stock]) };
        }
        case SET_STOCK_LOADING: {
            const { loading } = action.payload
            return {...state, loading }
        }
        default:
            return state
    }
}

const fromObjToArray = stock => (
    toPairs(stock).map(([key, value]) => ({ ...value, id: key }))
);

export const getStockData = stock => fromObjToArray(stock);